module.exports = __webpack_public_path__ + "img/telegraph.0d8dabd3.jpg";